<template >
  <v-col class="py-0">
    <!-- see vuetify v-input api -->
    <v-input
      v-show="false"
      :hide-details="true"
      :value="value"
      :rules="rules"
    />
  </v-col>
</template>

<script>
export default {
  props: {
    inputData: Object,
    rules: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    config: Object,
  },
  methods: {
    evalParam() {
      const { value } = this.params;
      return typeof value === 'function' ? value() : value;
    },
    emitValue(value) {
      this.$emit('update:inputData', { value });
    },
    sameValue(oldval, newval) {
      if (oldval != null && newval != null) {
        if (oldval instanceof Array && newval instanceof Array) {
          return oldval.every((i, idx) => newval[idx] === i);
        } if (typeof oldval === 'object' && typeof newval === 'object') {
          try {
            return JSON.stringify(oldval) === JSON.stringify(newval);
          } catch (ex) {
            return false;
          }
        }
      }
      return oldval === newval;
    },
  },
  data: () => ({
    value: null,
  }),
  created() {
    this.value = this.evalParam();
    this.emitValue(this.value);
  },
  computed: {
    globalContext() {
      return this.$parent.expressionInterpreter.ctx;
    },
  },
  watch: {
    globalContext() {
      const newval = this.evalParam();
      if (!this.sameValue(this.value, newval)) {
        this.value = newval;
        this.emitValue(this.value);
      }
    },
  },
  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>
